import React, { useEffect, useState } from "react";
import {
  ComposedChart,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  Area,
} from "recharts";
import { Dropdown } from "react-materialize";
import { useDispatch, useSelector } from "react-redux";
import { getCreateAuctionAnalystics } from "../../../../redux/action/analystics";
import { handleDateSetUp } from "../../../../helpers/helpers";
import TransactionLoader from "../../../loader/TransactionLoader";
function CreateAuctionLinechart() {
  const [createAnalystic, setCreateAnalystic] = useState([]);
  const [number, setNumber] = useState(3);
  const dispatch = useDispatch();

  const { analystics, loadings } = useSelector(
    (state) => state?.createAuctionAnalystics
  );

  useEffect(() => {
    dispatch(getCreateAuctionAnalystics());
  }, [dispatch]);

  useEffect(() => {
    const formattedData = analystics?.map((item) => ({
      ...item,
      _id: handleDateSetUp(item._id),
    }));
    setCreateAnalystic(formattedData);
  }, [analystics]);

  return (
    <>
      {loadings ? (
        <TransactionLoader />
      ) : (
        <div
          className="white full-width"
          style={{
            borderRadius: "12px",
            boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
            padding: "1rem 1rem 0rem 1rem",
          }}
        >
          <div className={`flex space-between mb-1`}>
            <h5 className="margin-0px">Create Auctions</h5>

            <Dropdown
              id="monthsDropdown"
              trigger={
                <div
                  className="valign-wrapper align-center cover grey lighten-3 font-cercular-bold black-text"
                  style={{ padding: "5px 25px" }}
                >
                  <p
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    Last {number} Months
                  </p>
                  <span
                    className="material-icons-outlined"
                    style={{ marginLeft: "0.5rem" }}
                  >
                    keyboard_arrow_down
                  </span>
                </div>
              }
            >
              <span onClick={() => setNumber(3)}>3 months</span>
              <span onClick={() => setNumber(6)}>6 Months</span>
              <span onClick={() => setNumber(12)}>1 Year</span>
              <span onClick={() => setNumber(24)}>2 Years</span>
            </Dropdown>
          </div>

          <ResponsiveContainer width="100%" height={170}>
            <ComposedChart data={createAnalystic}>
              {/* <CartesianGrid verticalPoints={[1]} /> */}
              <XAxis dataKey="_id" />
              {/* <YAxis /> */}
              <Tooltip content={<CustomTooltip />} />
              <Area
                type="monotone"
                dataKey="count"
                stroke="#1c0a84"
                fillOpacity={1}
                fill="url(#colorPvv)"
              />

              <defs>
                <linearGradient id="colorPvv" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#1c0a84" stopOpacity={1} />
                  <stop offset="95%" stopColor="#1c0a84" stopOpacity={0.7} />
                </linearGradient>
              </defs>
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      )}
    </>
  );
}

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="cover valign-wrapper p-1 grey lighten-5" style={{}}>
        <span>
          <p>{`${label}`}</p>
          <p>
            <span className="red-text">Auction Count:</span>
            {` ${payload[0].value}`}
          </p>
        </span>
      </div>
    );
  }
};

export default CreateAuctionLinechart;
